import React from 'react';
import { Button } from 'react-bootstrap';

const CommandButton = ({
  cmdObj,
  loading,
  onClick,
  getButtonLabel,
  getButtonColor,
  hasValue,
  feedback,
  isCalibration,
  criticalCommands,
  disabled = false,
  className = "w-100 py-2 mb-2"
}) => {
  return (
    <Button
      className={className}
      style={{
        fontWeight: 500,
        letterSpacing: 0.5,
        fontSize: '0.85rem',
        whiteSpace: 'pre-line',
        minHeight: hasValue ? '70px' : '50px',
        position: 'relative',
        backgroundColor: getButtonColor(),
        color: (isCalibration || cmdObj.params === 0 || criticalCommands.includes(cmdObj.cmd)) ? '#fff' : '#212529',
        border: hasValue 
          ? '2px solid var(--info-color, #0dcaf0)' 
          : (feedback?.type === 'success' 
              ? '2px solid var(--success-color, #198754)' 
              : feedback?.type === 'error' 
                ? '2px solid var(--danger-color, #dc3545)' 
                : 'none'),
        boxShadow: feedback?.type === 'success' 
          ? '0 0 10px rgba(25, 135, 84, 0.5)' 
          : feedback?.type === 'error' 
            ? '0 0 10px rgba(220, 53, 69, 0.5)' 
            : undefined
      }}
      onClick={onClick}
      disabled={loading || disabled}
    >
      {getButtonLabel(cmdObj)}
      {hasValue && (
        <span style={{
          position: 'absolute',
          top: 4,
          right: 4,
          background: 'var(--info-color, #0dcaf0)',
          color: 'white',
          borderRadius: '50%',
          width: 8,
          height: 8,
          display: 'inline-block'
        }} />
      )}
      {feedback && (
        <span style={{
          position: 'absolute',
          bottom: 4,
          right: 4,
          fontSize: '1rem'
        }}>
          {feedback.type === 'success' ? '✓' : '✗'}
        </span>
      )}
    </Button>
  );
};

export default CommandButton;
